import React, { useState } from "react";
import { Button, Col, Form, FormGroup, Input, Row, Spinner } from "reactstrap";

type Props = Readonly<{
  cancelEdit: (noteId: string) => void;
  initialContent: string;
  noteId: string;
  saveEdit: (noteId: string, content: string) => void;
}>;

export const EditNote = ({ cancelEdit, initialContent, noteId, saveEdit }: Props) => {
  const [content, setContent] = useState(initialContent);
  const [formDisabled, setFormDisabled] = useState(false);
  return (
    <Form
      onSubmit={e => {
        e.preventDefault();
        if (formDisabled) {
          return;
        }
        setFormDisabled(true);
        saveEdit(noteId, content);
      }}
    >
      <FormGroup>
        <Input
          disabled={formDisabled}
          onKeyDown={e => {
            e.stopPropagation();
            if (e.key.toLowerCase() === "escape") {
              cancelEdit(noteId);
            }
          }}
          onChange={e => {
            setContent(e.target.value);
          }}
          type="textarea"
          value={content}
        />
      </FormGroup>
      <Row>
        <Col className="align-items-center d-flex justify-content-between">
          <Button
            color="secondary"
            disabled={formDisabled}
            onClick={e => {
              e.preventDefault();
              cancelEdit(noteId);
            }}
            size="sm"
            type="reset"
          >
            Cancel
          </Button>
          {formDisabled && <Spinner size="sm" />}
          <Button color="primary" disabled={formDisabled} size="sm" type="submit">
            Save
          </Button>
        </Col>
      </Row>
    </Form>
  );
};
EditNote.displayName = "EditNote";
